<template>
	<div class="ppg-generation-result">
		<ul v-if="files.length" class="ppg-generation-result__list">
			<li
				v-for="(file, index) in files"
				:key="file.s3_id || index"
				class="ppg-generation-result__item"
			>
				<a
					href="#"
					class="ppg-generation-result__link"
					@click.prevent="openGeneratedWork(file)"
				>
					{{ getFileLabel(file, index) }}
				</a>
			</li>
		</ul>

		<vs-alert v-else-if="isError" color="danger">
			{{ result.value }}
		</vs-alert>

		<span v-else class="ppg-generation-result__empty">—</span>
	</div>
</template>

<script>
import notifier from "@/mixins/notifier";

export default {
	name: "PpgGenerationResult",
	mixins: [notifier],
	props: {
		result: { default: null, type: Object }
	},
	computed: {
		userRole() {
			return this.$store.state.auth.role;
		},

		files() {
			if (!this.result) {
				return [];
			}

			if (this.result.type === "files" && Array.isArray(this.result.files)) {
				return this.result.files.filter(file => file && file.s3_id);
			}

			// Backward compatibility with a single file payload.
			if (this.result.type === "file" && this.result.s3_id) {
				return [
					{
						s3_id: this.result.s3_id,
						file_name: this.result.file_name || this.result.name || "",
						name: this.result.name || this.result.file_name || ""
					}
				];
			}

			return [];
		},

		isError() {
			return (
				!!this.result &&
				this.result.type === "error" &&
				!!this.result.value
			);
		}
	},
	methods: {
		getFileLabel(file, index) {
			const name = file.file_name || file.name;
			if (name) {
				return name;
			}

			if (this.files.length === 1) {
				return this.$t("openGeneratedWork");
			}

			return `${this.$t("openGeneratedWork")} ${index + 1}`;
		},

		async openGeneratedWork(file) {
			try {
				const response = await this.$http.post(
					`/${this.userRole}/order/download-url`,
					{ s3_id: file.s3_id }
				);

				const downloadUrl = response.data.data.downloadUrl;

				if (!downloadUrl) {
					this.notifyError(this.$t("fileDownloadError"));
					return;
				}

				window.open(downloadUrl, "_blank");
			} catch (e) {
				this.notifyError(this.$t("fileDownloadError"));
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.ppg-generation-result {
	&__list {
		margin: 0;
		padding: 0;
		list-style: none;
	}

	&__item + &__item {
		margin-top: 0.35rem;
	}

	&__link {
		word-break: break-all;
	}

	&__empty {
		color: gray;
	}
}
</style>
